<div class="contract-form-container">
  <mat-card class="contract-card">
    <mat-card-content>
      @if (isLoadingData) {
        <div class="loading-container">
          <mat-spinner diameter="50"></mat-spinner>
          <p>Carregando dados...</p>
        </div>
      }

      @if (!isLoadingData) {
        <form
          [formGroup]="contractForm"
          (ngSubmit)="onSubmit()"
          class="contract-form"
        >
          <!-- Basic Information Section -->
          <div class="form-section">
            <h3 class="section-title">
              <mat-icon>info</mat-icon>
              Informações Básicas
            </h3>

            <div class="form-row">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Cliente</mat-label>
                <mat-select
                  formControlName="organizationId"
                  placeholder="Selecione o cliente"
                >
                  @for (org of organizations; track org) {
                    <mat-option [value]="org.id">
                      {{ org.name }} - {{ org.cnpj }}
                    </mat-option>
                  }
                </mat-select>
                @if (hasError("organizationId", "required")) {
                  <mat-error> Cliente é obrigatório </mat-error>
                }
              </mat-form-field>
            </div>

            <div class="form-row">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Número do Contrato</mat-label>
                <input
                  matInput
                  formControlName="contractNumber"
                  placeholder="Ex: CT-2025-001"
                  maxlength="100"
                />
                <mat-hint>Exemplo: CT-2025-001</mat-hint>
                @if (hasError("contractNumber", "required")) {
                  <mat-error> Número do contrato é obrigatório </mat-error>
                }
                @if (hasError("contractNumber", "maxlength")) {
                  <mat-error> Máximo 100 caracteres </mat-error>
                }
              </mat-form-field>
            </div>

            <div class="form-row">
              <mat-form-field appearance="outline" class="half-width">
                <mat-label>Data de Início</mat-label>
                <input
                  matInput
                  [matDatepicker]="startPicker"
                  formControlName="startDate"
                  placeholder="DD/MM/AAAA"
                  (dateChange)="onDateChange()"
                  (blur)="onDateBlur('startDate')"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="startPicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #startPicker></mat-datepicker>
                @if (
                  hasError("startDate", "required") &&
                  !hasError("startDate", "matDatepickerParse")
                ) {
                  <mat-error> Data de início é obrigatória </mat-error>
                }
                @if (hasError("startDate", "matDatepickerParse")) {
                  <mat-error> Formato inválido. Use DD/MM/AAAA </mat-error>
                }
              </mat-form-field>

              <mat-form-field appearance="outline" class="half-width">
                <mat-label>Data de Fim</mat-label>
                <input
                  matInput
                  [matDatepicker]="endPicker"
                  formControlName="endDate"
                  placeholder="DD/MM/AAAA"
                  (dateChange)="onDateChange()"
                  (blur)="onDateBlur('endDate')"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="endPicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #endPicker></mat-datepicker>
                @if (
                  hasError("endDate", "required") &&
                  !hasError("endDate", "matDatepickerParse")
                ) {
                  <mat-error> Data de fim é obrigatória </mat-error>
                }
                @if (hasError("endDate", "matDatepickerParse")) {
                  <mat-error> Formato inválido. Use DD/MM/AAAA </mat-error>
                }
                @if (hasError("endDate", "dateInvalid")) {
                  <mat-error
                    >A data de fim deve ser posterior à data de início do
                    contrato.</mat-error
                  >
                }
              </mat-form-field>
            </div>

            <div class="form-row">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Modalidade do Contrato</mat-label>
                <mat-select formControlName="modality">
                  @for (option of modalityOptions; track option) {
                    <mat-option [value]="option.value">
                      {{ option.label }}
                    </mat-option>
                  }
                </mat-select>
                @if (hasError("modality", "required")) {
                  <mat-error> Modalidade é obrigatória </mat-error>
                }
              </mat-form-field>
            </div>
          </div>

          <!-- Quantities Section -->
          @if (contractForm.controls.modality.value === "with_commitment") {
            <div class="form-section">
              <h3 class="section-title">
                <mat-icon>assessment</mat-icon>
                Quantitativos Contratados
              </h3>

              <div class="quantities-section">
                <div class="form-row">
                  <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Relatórios de Compliance</mat-label>
                    <input
                      matInput
                      type="number"
                      [formControl]="
                        contractForm.controls.complianceReportsAmount
                      "
                      min="0"
                      placeholder="0"
                    />
                    <mat-hint>Número de relatórios contratados</mat-hint>
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Relatórios de Histórico</mat-label>
                    <input
                      matInput
                      type="number"
                      [formControl]="contractForm.controls.historyReportsAmount"
                      min="0"
                      placeholder="0"
                    />
                    <mat-hint>Número de relatórios contratados</mat-hint>
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="half-width">
                    <mat-label>Hectares (ha)</mat-label>
                    <input
                      matInput
                      type="number"
                      [formControl]="
                        contractForm.controls.monitoringHectaresAmount
                      "
                      min="0"
                      placeholder="0"
                    />
                    <span matSuffix>ha</span>
                    <mat-hint>Total de hectares (ha) contratados</mat-hint>
                  </mat-form-field>
                </div>
              </div>
            </div>
          }

          <!-- Available Products Section (Without Commitment) -->
          @if (contractForm.controls.modality.value === "without_commitment") {
            <div class="form-section">
              <h3 class="section-title">
                <mat-icon>card_giftcard</mat-icon>
                Produtos Disponíveis
              </h3>

              <div class="products-grid">
                <mat-card class="product-card">
                  <mat-card-content>
                    <div class="product-checkbox">
                      <mat-checkbox
                        [checked]="
                          contractForm.controls.complianceReportsAmount
                            .value === null &&
                          contractForm.controls.complianceReportsAmount
                            .value !== 0
                        "
                        (change)="
                          $event.checked
                            ? contractForm.controls.complianceReportsAmount.setValue(
                                null
                              )
                            : contractForm.controls.complianceReportsAmount.setValue(
                                0
                              )
                        "
                      >
                        <strong>Relatórios de Compliance</strong>
                        <p class="product-description">
                          Solicitação de relatórios de compliance durante o
                          período do contrato
                        </p>
                      </mat-checkbox>
                    </div>
                  </mat-card-content>
                </mat-card>

                <mat-card class="product-card">
                  <mat-card-content>
                    <div class="product-checkbox">
                      <mat-checkbox
                        [checked]="
                          contractForm.controls.historyReportsAmount.value ===
                            null &&
                          contractForm.controls.historyReportsAmount.value !== 0
                        "
                        (change)="
                          $event.checked
                            ? contractForm.controls.historyReportsAmount.setValue(
                                null
                              )
                            : contractForm.controls.historyReportsAmount.setValue(
                                0
                              )
                        "
                      >
                        <strong>Relatórios de Histórico</strong>
                        <p class="product-description">
                          Solicitação de relatórios de histórico agrícola
                          durante o período do contrato
                        </p>
                      </mat-checkbox>
                    </div>
                  </mat-card-content>
                </mat-card>

                <mat-card class="product-card">
                  <mat-card-content>
                    <div class="product-checkbox">
                      <mat-checkbox
                        [checked]="
                          contractForm.controls.monitoringHectaresAmount
                            .value === null &&
                          contractForm.controls.monitoringHectaresAmount
                            .value !== 0
                        "
                        (change)="
                          $event.checked
                            ? contractForm.controls.monitoringHectaresAmount.setValue(
                                null
                              )
                            : contractForm.controls.monitoringHectaresAmount.setValue(
                                0
                              )
                        "
                      >
                        <strong>Monitoramento</strong>
                        <p class="product-description">
                          Solicitação de monitoramentos durante o período do
                          contrato
                        </p>
                      </mat-checkbox>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          }

          <!-- Form Actions -->
          <div class="form-actions">
            <button
              mat-button
              type="button"
              (click)="onCancel()"
              [disabled]="isLoading"
            >
              Cancelar
            </button>
            <button
              mat-flat-button
              color="primary"
              type="submit"
              [disabled]="!contractForm.valid || isLoading"
            >
              @if (isLoading) {
                <mat-spinner diameter="20" class="button-spinner"></mat-spinner>
              }
              @if (!isLoading) {
                <mat-icon>{{ isEditMode ? "save" : "add" }}</mat-icon>
              }
              {{ isEditMode ? "Atualizar Contrato" : "Cadastrar Contrato" }}
            </button>
          </div>
        </form>
      }
    </mat-card-content>
  </mat-card>
</div>
